

// import React, { useEffect, useState, useRef } from 'react';

// import Slider from 'react-slick';
// import Testmonial from './Testmonial';


// import Newtestmonial from './Newtestmonial';
// import Circle from'./Circle';



// const PCMobileApplications = () => {
//   const [toggle, setToggle] = useState(1);
//   const [navbarHeight, setNavbarHeight] = useState(2); // Default navbar height
//   const [tabVR, setTabVR] = useState(2);
//   const [tabPages, setTabPages] = useState(1); // For new tab group
//   const [mainTab, setMainTab] = useState(2);
//   function updateTabsVR(num) {
//     setTabVR(num);
//   }
//   const [activeButton, setActiveButton] = useState(null);
 

//   const updateToggle = (id) => {
//     setActiveButton(id);  // Set the clicked button as active
//     setToggle(id);         // Set the toggle state
//   };
//   const updateMainTabs = (tabIndex) => {
//     setMainTab(tabIndex);
//   };




//   // Create a ref for the show-the-content container
//   const contentRef = useRef(null);

//   // Function to update sub-tabs and scroll smoothly
//   const handleSubTabClick = (tabNumber) => {
//     updateSubTabs(tabNumber); // Your existing function to update sub-tabs

//     // Scroll to the show-the-content container with an offset
//     setTimeout(() => {
//       if (contentRef.current) {
//         const offset = 180; // Adjust this value to control how much of the top you want to show
//         const elementPosition = contentRef.current.getBoundingClientRect().top + window.scrollY;
//         window.scrollTo({
//           top: elementPosition - offset,
//           behavior: 'smooth',
//         });
//       }
//     }, 0);
//   };




//   const updateSubTabs = (tabIndex) => {
//     setSubTab(tabIndex);
//   };

//   const tabContentRef = useRef(null);

//   const handleTabClick = (tabIndex) => {
//     // Scroll to the respective tab content section
//     if (tabContentRef.current) {
//       tabContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };




//   const [subTab, setSubTab] = useState(5);  // Default sub tab
  




  
 
//   const contentRefs = {
//     tab5: useRef(null),
//     tab2: useRef(null),
//     tab3: useRef(null),
//   };

//   const scrollToTop = (tabId) => {
//     if (contentRefs[tabId] && contentRefs[tabId].current) {
//       contentRefs[tabId].current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   useEffect(() => {
//     // Scroll to top on mount
//     window.scrollTo(0, 0);

//     // Calculate navbar height
//     const navbar = document.querySelector('.navbar');
//     if (navbar) {
//       setNavbarHeight(navbar.offsetHeight);
//     }
//   }, []);

//   const settingss = {
//     dots: false, // Show dots for navigation
//     infinite: true, // Enable infinite scrolling
//     arrows: false,
//     autoplay: true,
//     speed: 500, // Transition speed
//     slidesToShow: 3, // Number of items to show at once
//     slidesToScroll: 1, // Number of items to scroll per action
//     responsive: [
//       {
//         breakpoint: 768, // For screens smaller than 768px
//         settings: {
//           slidesToShow: 1, // Show 1 slide at a time
//           slidesToScroll: 1, // Scroll 1 slide at a time
//         },
//       },
//     ],
//   };

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     pauseOnHover: true,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         },
//       },
//     ],
//   };


  

//   const cardStyle = {
//     textDecoration: 'none',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     marginTop:'-30px',
//     margin: '10px auto',
//     width: '80%',
//     color: 'white',
//     fontSize: '16px',
//     fontWeight: '700',
//     padding: '10px 65px',
//     borderRadius: '10px',
//     backgroundColor: 'blue',
//     transition: 'all 0.3s ease',
//     textAlign: 'center',
//     marginTop:'-27px',
//     gap:10
   
//   };

//   const handleMouseEnter = (e) => {
//     e.target.style.backgroundColor = 'black';
//     e.target.style.transform = 'translateY(-4px)';
//   };

//   const handleMouseLeave = (e) => {
//     e.target.style.backgroundColor = 'blue';
//     e.target.style.transform = 'translateY(0)';
//   };

//   return (
//     <div style={{ backgroundColor: 'white' }}>
      
//       {/* Hero Section */}
//       <div className={toggle === 1 ? 'show-the-content' : 'dont-show-content'}>
       
//       </div>

//       <div className={toggle === 2 ? 'show-the-content' : 'dont-show-content'}>
       
//       </div>

//       <div className={toggle === 3 ? 'show-the-content' : 'dont-show-content'}>
      
//       </div>

     
//       <div>
       
//       </div>

//       <div style={{ backgroundColor: 'white' }}>




        
//     <div
//       className="icon-slider-wrapper"
//       style={{
//         position: 'sticky',
//         top: 76,
//         zIndex: 1000,
//         width: '100%',
//         margin: '0 auto',
//         background: 'transparent',
//        padding:'10px 35px',
//        marginTop:'323px'
//       }}
//     >
//       <Slider {...settings}>
//         {['TecTalks', 'Programs', 'Jobs','WalkingDrive'].map((item) => (
//           <div key={item} style={{ textAlign: 'center' }}>
//             <a 
//               href="Newallcardspage"
//               className="filter inform slidertext-box"
//               style={cardStyle}
//               onMouseEnter={handleMouseEnter}
//               onMouseLeave={handleMouseLeave}
//             >
//               {item}
//             </a>
//           </div>
//         ))}
//       </Slider>
//     </div> 

// {/* <Testmonial/> */}
//           <Newtestmonial/>
   
//           <Circle/>
      
//         <div className={toggle === 3 ? 'show-the-content' : 'dont-show-content'}>
    
        
         
           

//           <div className={mainTab === 2 ? 'show-the-content' : 'dont-show-content'}>
          
          
//           </div>
//           <div className={mainTab === 9 ? 'show-the-content' : 'dont-show-content'}>
 
                  
//           </div>

//           <div className={mainTab === 3 ? 'show-the-content' : 'dont-show-content'}>
            
//           </div>


//           <div className={mainTab === 4 ? 'show-the-content' : 'dont-show-content'}>
           
          
//           </div>
          
//         </div>
       


//         <div className={toggle === 1 ? 'show-the-content' : 'dont-show-content'}>
//           <div>
           
        

//             <>
              


//               {mainTab === 4 && (
//                 <div ref={contentRef} className="show-the-content">

//                 </div>
//               )}
//               {mainTab === 2 && (
//                 <div ref={contentRef} className="show-the-content">
                 
                 

//                 </div>
//               )}

//             </>



//             {mainTab === 3 && (
//               <>
//                 {subTab === 5 && (
//                   <div className="show-the-content">

                    
                   
//                   </div>
//                 )}
     
//               </>
//             )}
//           </div>

//         </div>



//         <div className={toggle === 2 ? 'show-the-content' : 'dont-show-content'}>
//           <div>

//             <div className="reCreateTabs" style={{
//               position: 'sticky',
//               top: `${navbarHeight + 2}px`,
//               backgroundColor: '#fff',
//               // padding: '10px 0',
//               zIndex: 996,
              
//             }}>
//               <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0 }}>
                
               

//               </ul>
//             </div>

         
//             <div className="reCreateTabs  dfs all-data-tabs" style={{
//               position: 'sticky',
//               top: `${navbarHeight + 99}px`,
//               backgroundColor: '#fff',
//               // padding: '10px 0',
//               zIndex: 998,
//               marginTop:'-12px'
//             }}>
//               <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0 }}>
                
               


//               </ul>
//             </div>

           

           
//             {mainTab === 2 && subTab === 5 && (
//               <div ref={contentRef} className="show-the-content">
                
//               </div>
//             )}
//             {mainTab === 5 && (
//               <div ref={contentRef} className="show-the-content">
                
//               </div>
//             )}
//             {mainTab === 3 && (
//               <div ref={contentRef} className="show-the-content">
                
//               </div>
//             )}
//             {mainTab === 2 && subTab === 4 && (
//               <div ref={contentRef} className="show-the-content">
                
//               </div>
//             )}


//           </div>

//         </div>



//       </div>

//       <style>
//         {`
//             .show-the-content {
//               display: block;
//             }

//             .dont-show-content {
//               display: none;
//             }

//             h1, h2, h3, h4, h5, h6, p {
//               font-family: urbanist, serif;
//             }

//             .reCreateTabs ul {
//               display: flex;
//               justify-content: center;
//               list-style: none;
//               padding: 0;
//               margin: 0;
//               flex-wrap: wrap;
//             }

//             .reCreateTabs ul li {
//               display: inline-block;
//               padding: 10px 20px;
//               font-size: 16px;
//               background-color: black;
//               border-radius: 10px;
//               color: white;
//               margin: 5px;
//               cursor: pointer;
//               text-align: center;
//             }

//             .reCreateTabs ul li:hover {
//               color: orange;
//               background-color: gray;
//             }

//             /* Responsive Styles */
//             @media (max-width: 768px) {
//               .reCreateTabs ul li {
//                 font-size: 14px;
//                 padding: 8px 15px;
//               }
//             }

//             @media (max-width: 480px) {
//               .reCreateTabs ul li {
//                 font-size: 12px;
//                 padding: 6px 10px;
//               }

//               .reCreateTabs ul {
//                 flex-direction: column;
//                 // align-items: center;
//               }
//             }

//              @media (max-width: 600px) {
//     .reCreateTabs ul {
//       flex-direction: column; /* Stack tabs vertically on small screens */
//       padding: 0; /* Remove any extra padding */
//     }

//     .reCreateTabs ul li {
//       font-size: 18px !important; /* Make the font smaller */
//       padding: 16px 15px !important; /* Reduce padding to make the tab smaller */
//     }
//   }

// ul {
//   list-style-type: none; /* Removes bullet points */
//   margin: 0; /* Removes any default margin */
//   padding: 0; /* Removes any default padding */
// }


              
//         `}
//       </style>
//     </div>

//   );
// };

// export default PCMobileApplications;




// import React, { useEffect, useState } from 'react';

// import Testmonial from './Testmonial';


// import Newtestmonial from './Newtestmonial';
// import Circle from'./Circle';

// const StickyButtonNav = () => {
//   const [isSticky, setIsSticky] = useState(false);

//   // Scroll handler to toggle sticky class
//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       setIsSticky(offset > 100); // Adjust as needed
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const buttons = [
//     { label: 'Workshops', link: '/workshops' },
//     { label: 'Comedy Shows', link: '/comedy' },
//     { label: 'Music Shows', link: '/music' },
//     { label: 'Meetups', link: '/meetups' },
 
//   ];

//   return (
//     <div style={{ height: 'auto' }}>
//       <div
//         className={`button-nav ${isSticky ? 'sticky' : ''}`}
//         style={{
//           position: isSticky ? 'fixed' : 'relative',
//           top: isSticky ? 83 : '264px',
//           zIndex: 999,
//           width: '100%',
//           background: 'white',
//           padding: '10px 0',
//           boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1200px',
//             margin: '0 auto',
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '15px',
//             padding: '0 15px',
           
//           }}
//         >
//           {buttons.map((btn, index) => (
//             <a
//               key={index}
//               href={btn.link}
//               style={{
//                 padding: '10px 20px',
//                 border: '2px solid #ccc',
//                 borderRadius: '30px',
//                 textDecoration: 'none',
//                 color: 'crimson',
//                 fontSize: '16px',
//                 whiteSpace: 'nowrap',
//                 transition: 'all 0.3s ease',
                
//               }}
//               onMouseOver={e => (e.currentTarget.style.background = '#f0f0f0')}
//               onMouseOut={e => (e.currentTarget.style.background = 'transparent')}
//             >
//               {btn.label}
//             </a>
//           ))}
//         </div>
//       </div>
//         <Newtestmonial/>
   
//            <Circle/>
//     </div>
  
//   );
// };

// export default StickyButtonNav;



// import React, { useEffect, useState } from 'react';
// import Newtestmonial from './Newtestmonial';
// import Circle from './Circle';
// import Testmonial from './Testmonial';

// import Alldisplay from './Alldisplay'

// const StickyButtonNav = () => {
//   const [isSticky, setIsSticky] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 100); // Optional: adjust offset
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const buttons = [
//     { label: 'Tec Talks', link: '/Newallcardspage' },
//     { label: 'Programs', link: '/Secondactiveprograms' },
//     // { label: 'Jobs', link: '/Newallcardspage' },
//     // { label: 'Walking Drive', link: '/Newallcardspage' },
//   ];

//   return (
//     <div style={{ height: 'auto' }}>
//       <div
//         className={`button-nav ${isSticky ? 'sticky' : ''}`}
//         style={{
//           position: isSticky ? 'fixed' : 'relative',
//           top: isSticky ? 99 : '264px', // adjust as needed
//           zIndex: 999,
//           width: '100%',
//           background: 'white',
//           padding: '10px 0',
//           boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
//           transition: 'top 0.3s ease',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1200px',
//             margin: '0 auto',
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'center',
//             gap: '15px',
//             padding: '0 15px',
//           }}
//         >
//           {buttons.map((btn, index) => (
//             <a
//               key={index}
//               href={btn.link}
//               style={{
//                 padding: '10px 20px',
//                 border: '2px solid blue',
//                 borderRadius: '30px',
//                 textDecoration: 'none',
//                 background: 'blue',
//                 color: 'white',
//                 fontSize: '16px',
//                 whiteSpace: 'nowrap',
//                 transition: 'all 0.3s ease',
//               }}
//               onMouseOver={e => {
//                 e.currentTarget.style.background = '#003399'; // darker blue
//               }}
//               onMouseOut={e => {
//                 e.currentTarget.style.background = 'blue';
//               }}
//             >
//               {btn.label}
//             </a>
//           ))}
//         </div>
//       </div>

//       {/* Below Content */}
//       <div style={{marginTop:'314px'}}>

//         <Alldisplay/> 
// <Testmonial/>
//       </div>
//       {/* <Anmitioncomponatcard/> */}
//       <Newtestmonial />
      
//       <Circle />
//     </div>
//   );
// };

// export default StickyButtonNav;




import React, { useEffect, useState } from 'react';

import Circle from './Circle';
import Testmonial from './Testmonial';
import Alldisplay from './Alldisplay';
import Whychoose from './Whychoose';

const StickyButtonNav = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // Track active button

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const buttons = [
    // { label: 'Tec Talks', link: '/Newallcardspage' },
    { label: 'Programs', link: '/Secondactiveprograms' },
    //  { label: 'Career Program', link: '/Thirdactiveprogram' },
  ];

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div style={{ height: 'auto' }}>
      <div
        style={{
          position: isSticky ? 'fixed' : 'relative',
          top: isSticky ? 84 : '264px',
          zIndex: 999,
          width: '100%',
          background: 'white',
          padding: '10px 0',
          boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.1)' : 'none',
          transition: 'top 0.3s ease',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '15px',
            padding: '0 15px',
          }}
        >
          {buttons.map((btn, index) => (
            <a
              key={index}
              href={btn.link}
              onClick={() => handleClick(index)}
              style={{
                padding: '10px 25px',
                border: '2px solid ',
                borderRadius: '30px',
                textDecoration: 'none',
                background: activeIndex === index ? 'blue' : '#f7941d',
                color: 'white',
                fontWeight: activeIndex === index ? 'bold' : 'normal',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              {btn.label}
            </a>
          ))}
        </div>
      </div>

      <div style={{ marginTop: '314px',backgroundColor:'blue' }}>
        <Alldisplay />
         <Whychoose/>
       
      </div>
     
      <Circle />
    </div>
  );
};

export default StickyButtonNav;



